// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-features-Modal-CompanyModal-Tab-CorpName-style__container--wclZ7{margin-top:16px}.src-features-Modal-CompanyModal-Tab-CorpName-style__tableContainer--b26QT{margin-top:16px;height:292px}", "",{"version":3,"sources":["webpack://./src/features/Modal/CompanyModal/Tab/CorpName/style.scss"],"names":[],"mappings":"AACA,sEACE,eAAA,CAGF,2EACE,eAAA,CACA,YAAA","sourcesContent":["@use 'src/utils/css/variables' as *;\n.container {\n  margin-top: 16px;\n}\n\n.tableContainer {\n  margin-top: 16px;\n  height: 292px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lHeaderHeight": "56px",
	"lCompanyHeight": "114px",
	"h2FontSize": "28px",
	"h3FontSize": "20px",
	"bodyLineHeight": "20px",
	"lGnShrinkWindowWidth": "1591px",
	"tableVerticalPadding": "8px",
	"tableHorizontalPadding": "16px",
	"lPersonnelBreakWidth": "1599px",
	"cNavigationAccent": "#f57f17",
	"cTableBodyOdd": "#fff",
	"cTableBodyEven": "#f2f6f8",
	"cTableHover": "#c5ddeb",
	"cTableHeadOdd": "#eaf1f5",
	"cTableHeadEven": "#dee8ef",
	"zPageLoading": "2",
	"container": "src-features-Modal-CompanyModal-Tab-CorpName-style__container--wclZ7",
	"tableContainer": "src-features-Modal-CompanyModal-Tab-CorpName-style__tableContainer--b26QT"
};
export default ___CSS_LOADER_EXPORT___;
